import { sagas as publisherDashboardSaga } from './pages/Dashboard/ducks'

export default () => [...publisherDashboardSaga()]
